<template>
    <el-amap vid="amapDemo" :zoom="zoom" :center="center" :scrollWheel="scrollWheel">
        <el-amap-marker v-for="(marker,index) in markers" :position="marker.position" :key="index">
        </el-amap-marker>
        <el-amap-info-window v-for="(window,index) in windows" :title="window.title" :position="window.position" :content="window.content"
                             :open="window.open" :key="index"></el-amap-info-window>
    </el-amap>
</template>

<script>
    export default {
        data () {
            return {
                isTransparent: false,
                zoom: 14,
                center: [121.52329,25.085144],
                scrollWheel: false,
                markers: [],
                windows: [
                    {
                        title: 'sasdasd',
                        content: this.$t('contact_us_company_taiwan_address'),
                        position: [121.52329,25.085144]
                    }
                ]
            }
        },
        mounted () {
            // 姑且N为2
            // 这样地图上就添加了两个人
            this.markers = [
                {
                    position: [121.52329,25.085144]
                }
            ]
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// zero.vue?0c1349f2